import React from "react";

const HandleRange = ({ handleFreely, handleWeekly, handleMonthly }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="font-medium text-gray-700">Select range:</div>
            <label className="flex items-center gap-2">
                <input type="radio" name="range" onClick={handleMonthly} />
                <span>Monthly</span>
            </label>
            <label className="flex items-center gap-2">
                <input type="radio" name="range" onClick={handleWeekly} />
                <span>Weekly</span>
            </label>
            <label className="flex items-center gap-2">
                <input type="radio" name="range" onClick={handleFreely} />
                <span>Free Range</span>
            </label>
        </div>
    );
};

export default HandleRange;
